import React from 'react';
import { Skeleton } from 'twain-sport-fe-mono/components/Skeleton';
import classes from './ParticipantProfileStatisticsSkeleton.module.scss';

export const StatisticValueSkeleton = () => <Skeleton className={classes.statValue} />;

export const StatisticRowSkeleton = () => <Skeleton className={classes.statRow} />;
